module.exports = __webpack_public_path__ + "static/media/google-maps.7a62ecaa.png";